import React from 'react';
import PropTypes from 'prop-types';
import branch from 'recompose/branch';
import classnames from 'classnames';
import renderNothing from 'recompose/renderNothing';
import './spinner.scss';

export const enhance = branch(({ show }) => !show, renderNothing);

export function Spinner({ inline }) {
	return (
		<div className={classnames('ph-spinner', { inline })} />
	);
}

Spinner.propTypes = {
	inline: PropTypes.bool
};

export default enhance(Spinner);
